// Content Management Component for Admin Dashboard
import React from 'react';
import FormTreeEditor from '../form-editor/form_tree_editor';

const ContentManagement = ({ onBack }) => {
  return (
    <div className="content-management">
      {/* Header with Back Button */}
      <div className="management-header">
        <div className="header-left">
          <button className="back-btn" onClick={onBack}>
            ← Back to Dashboard
          </button>
          <h2>Content Management</h2>
        </div>
      </div>

      {/* Form Tree Editor */}
      <div className="content-editor-container">
        <FormTreeEditor />
      </div>
    </div>
  );
};

export default ContentManagement;